import React from "react";

function generateMerchantSubtitle(merchant) {
    if (merchant.name !== 'Visa' && merchant.name !== 'Mastercard' &&
        (parseFloat(merchant.max_discount_percentage) !== 0 || parseFloat(merchant.max_cash_back_value) !== 0)
    ) {
        return (parseFloat(merchant.max_cash_back_value) !== 0)
            ? <><span className="bold">${parseFloat(merchant.max_cash_back_value).toFixed(2)} cash back</span></>
            : <><span className="bold">{Math.round(merchant.max_discount_percentage)}% off</span></>;
    }

    return <React.Fragment>&nbsp;</React.Fragment>;
}

export default generateMerchantSubtitle;